'use strict';
let _ = require('lodash');
let groupBy = require('lodash/groupBy');
import 'bootstrap-v4-dev'
import Shuffle from '../_modules/shuffle/shuffle'
//import { data } from '../_modules/data/data'
let Sifter = require('sifter')
import 'velocity-animate'
import 'velocity-animate/velocity.ui'
import 'sticky-kit/dist/sticky-kit.js';
import React from 'react';
import ReactDOM from 'react-dom';
import {data} from './data';


class SocialShare extends React.Component {
  process (mode) {
    if (mode === "facebook") {
      let description;
      if (this.props.kirja === 'Mika Waltari' || this.props.kirja === 'Sofi Oksanen' || this.props.kirja === 'Ilkka Remes') {
        console.log("poikkeus")
        description =  "Lähdenkin tästä lukemaan! Katso mitä Kirjakone arpoo sinulle."
      } else {
        description = "Tämä ja muut sadan vuoden kirjat löytyvät e-kirjoina Kirjakoneesta. Katso mitä kone arpoo sinulle!"
      }

      FB.ui({
        method: 'feed',
        picture: this.props.kuva,
        display: 'popup',
        name: 'Kirjakone valitsi minulle: ' + this.props.kirja + ' – ' +this.props.kirjailija,
        link: 'http://yle.fi/aihe/artikkeli/2016/12/29/lukemista-vailla-anna-kirjakoneen-auttaa',
        description: description
      }, function(response) {});

    } else if (mode === "twitter") {
        window.open("https://twitter.com/intent/tweet?text=Ylen Kirjakone valitsi minulle: " + this.props.kirja + " – " + this.props.kirjailija + ". &hashtags=kirjojensuomi&url=http://yle.fi/aihe/artikkeli/2016/12/29/lukemista-vailla-anna-kirjakoneen-auttaa");
    } else if (mode === "gplus") {
      window.open("https://plus.google.com/share?url=http://yle.fi/aihe/artikkeli/2016/12/29/lukemista-vailla-anna-kirjakoneen-auttaa");
    } else {
      return false;
    }
  }

  render () {
    let fbStyle = {
      marginLeft: "5px",
      marginRight: "5px",
      cursor: "pointer",
      color: "black",
      marginBottom: "20px"
    }
    return (
    <div className="socialShareButtons" style={{textAlign: "center"}}>
      <h5 style={{marginTop: "15px", marginBottom: "15px"}}>Jaa tuloksesi:</h5>
      <i className="fa fa-facebook-square fa-2x" aria-hidden="true" style={fbStyle} onClick={ () => {this.process("facebook")}}></i>
      <i className="fa fa-twitter-square fa-2x" aria-hidden="true" style={fbStyle} onClick={ () => {this.process("twitter")}}></i>
      <i className="fa fa-google-plus-square fa-2x" aria-hidden="true" style={fbStyle} onClick={ () => { this.process("gplus")}}></i>
    </div>
    )
  }
}

class PanicButton extends React.Component {

  scroll () {
    jQuery('.scrollAnchor').velocity("scroll", { duration: 10, easing: "spring", offset: -200 })
    this.props.handlePanicState();
  }

  render () {
    return (
      <div className="random" id="panic" onClick={this.scroll.bind(this)} >Paniikki – Kokeilen onneani</div>
    )
  }
}

class Header extends React.Component {
  render () {
    return (
    <div className="header">
      <div className="row">
        <div className="col-lg-12 logoContainer"><img src="http://www.yle.fi/plus/other/2016_kirjakone/images/logo.jpg" width="100%" /></div>
      </div>
      <div className="row">
        <div className="col-lg-10 offset-lg-1 ingressi"><p>
Sotaa, suuria tunteita vai hyytävää jännitystä? Kirjakone auttaa löytämään juuri
sinulle sopivan kirjan. Kirjakone sisältää sata kotimaista kirjaa –
yhden jokaiselta itsenäisyyden vuodelta.
Ja mikä parasta: pääset lukemaan lähes kaikki kirjat e-kirjoina,
välittömästi. Anna Kirjakoneen yllättää!
         </p>
          <PanicButton handlePanicState={this.props.handlePanicState}/>
        </div>
      </div>
    </div>
    )
  }
}


class MobileShowResults extends React.Component {
  componentDidMount() {
    $('.mobileShowResults').on('click', function () {
      jQuery('.resultsCont')
      .velocity("scroll", { duration: 10, easing: "spring", offset: -200 })
    });
  }

  render () {
    if (this.props.resultData) {
      let firstBookID = this.props.resultData[Object.getOwnPropertyNames(this.props.resultData)[0]][0].id
      return (
      <div className="col-lg-12">
        <div className="card card-block">
        <b>Paras tulos tähän mennessä:</b> <p>{data[firstBookID]["Kirjailija"]} - {data[firstBookID]["Kirja"]}</p>
        <p><span className="mobileShowResults">
        <a href="#">Näytä tulokset </a></span>
        tai jatka eteenpäin.</p>
        </div>
      </div>
      )
    } else {
      return false;
    }
  }
}


class InputSet extends React.Component {

  constructor (props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      mobileActive: false
    }
  }

  handleClick (event) {
    // This function calculates how many of the buttons have been clicked (that is, they have the class 'clicked')
      jQuery(event.currentTarget).toggleClass('clicked');
      let groupNumber = $(".btn-group").index( jQuery(event.currentTarget).parent());
      let answerArray = [];
      $(event.currentTarget).parent().children('.navButton').each(function () {
        if ($(this).hasClass('clicked')) {
          answerArray.push($(this).attr('name'))
        } else {
          answerArray.push("")
        }
      });
      var AAJoined = answerArray.join(" ");
      //callbackFunc(groupNumber, AAJoined, container);
      //this.tulokset[groupNumber] = AAJoined
      this.props.resultFunc(null, AAJoined, groupNumber)
  }

  checkMobileCont () {
    if (this.props.container != null) {
      if (this.props.container === this.props.number) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  render () {
    return (
      <div className="col-lg-12 set">
        <div className="col-xs-12 navheader"><h5>{this.props.name}</h5></div>
        <div className="btn-group btn-group col-lg-12" data-toggle="buttons">
        {
          this.props.data.map((function (object) {
            return <div className="col-lg-12 navButton" key={object[0]} onClick={this.handleClick.bind(this)} name={object[0]}>{object[1]}</div>
        }).bind(this))}
        </div>
        {
          (this.checkMobileCont() && this.props.mobile ) ? <MobileShowResults resultData={this.props.resultData} /> :  false
        }
      </div>
    )
  }
}

class ResultCont extends React.Component {
  componentDidUpdate() {
    if (!this.props.panic && !this.props.mobile) {
      $(".sticky").stick_in_parent({offset_top: -500, bottoming: true});
    } else {
      $(".sticky").trigger("sticky_kit:detach");
    }
  }


 loopThroughResults () {
   let i = 0;
   this.readMoreArray = [];
   for (var key in this.props.resultData) {
     if (i > 4) {
       return false;
     }
     if (!this.props.resultData.hasOwnProperty(key)) continue;

     var obj = this.props.resultData[key];
     for (var prop in obj) {
         if(!obj.hasOwnProperty(prop)) continue;

      if (i === 0) {
        this.firstBook = obj[prop].id
      } else {
        if (i > 4) {
          return false;
        } else {
          this.readMoreArray.push(obj[prop].id)
        }
      }
      i++;
     }

  }

 }

 update () {
   this.forceUpdate();
 }

 readMore (firstBookID) {
  if (data[firstBookID]["Kirjailija"] === 'Mika Waltari' || data[firstBookID]["Kirjailija"] === 'Sofi Oksanen' || data[firstBookID]["Kirjailija"] === 'Ilkka Remes') {
    return <p className="card-text nosto-inkku">Tätä teosta emme valitettavasti voi tarjota e-kirjana.</p>
   } else {
    return <p className="card-text nosto-inkku"><a href={data[firstBookID]["Fynd-artikkelin url"]}>Lue kirja täältä.</a></p>
    }
 }

 render () {
  this.loopThroughResults();
  let fbStyle = {
    "marginRight": "10px"
  }
  let readMoreStyle = {
    color: "white",
    lineHeight: "1.2em"
  }
  if (this.props.resultData) {
    let firstBookID = this.props.resultData[Object.getOwnPropertyNames(this.props.resultData)[0]][0].id
    let imageURL = "https://images.cdn.yle.fi/image/upload/fl_keep_iptc,f_auto,fl_progressive/" + data[firstBookID]["IMS julkinen ID"] + ".jpg";
    let topBook =
    <div className="sticky">
      <div className="card hot">
        <div className="card-img">
          <img className="card-img-top" width="100%" src={imageURL} alt="Ladataan" />
        </div>
        <div className="card-block">
          <h2>Kirjakone suosittelee sinulle: </h2>
          <p className="card-text nosto-otsikko">{data[firstBookID]["nosto-otsikko"]}</p>
          {this.readMore(firstBookID)}
        </div>
        <SocialShare kirjailija={data[firstBookID]["Kirja"]} kirja={data[firstBookID]["Kirjailija"]} kuva={imageURL} />
     </div>
     <div>
                 <h4>Myös nämä saattavat kiinnostaa sinua</h4>
     {this.readMoreArray.map(function(object, i){
       return (
         <p key={i}><a href={data[object]["Fynd-artikkelin url"]} style={readMoreStyle}>{data[object]["nosto-otsikko"]}</a></p>
       )
     })
     }
     </div>
  </div>
;
    return (
    <div className="col-lg-7">
      <div className="resultsCont">
            {topBook}
      </div>
    </div>
  )
} else if (this.props.panic) {
  let shuffledArray = data.slice();
  let shuffled = new Shuffle(shuffledArray)
  shuffled.createRandomArray();

  const tryAgainStyle = {
  marginTop: '20px'
  };

  let imageURL = "https://images.cdn.yle.fi/image/upload/fl_keep_iptc,f_auto,fl_progressive/" + shuffledArray[0]["IMS julkinen ID"] + ".jpg";
  return (
    //RANDOM BOOK
    <div className="col-lg-7">
      <div className="resultsCont">
        <div className="sticky">
            <div className="card hot">
                <div className="card-img">
                  <img className="card-img-top" width="100%" src={imageURL} alt="Ladataan" />
                </div>
                <div className="card-block">
                  <h2>Kirjakoneen valinta: </h2>
                  <p className="card-text nosto-otsikko">{shuffledArray[0]["nosto-otsikko"]}</p>
                  <p className="card-text nosto-inkku"><a href={shuffledArray[0]["Fynd-artikkelin url"]}>Lue kirja täältä.</a></p>
                  <SocialShare kirjailija={shuffledArray[0]["Kirja"]} kirja={shuffledArray[0]["Kirjailija"]} kuva={imageURL} />
                  <div className="random2" id="panic2" onClick={this.update.bind(this)} style={tryAgainStyle}>Kokeile uudestaan</div>
                </div>
           </div>
        </div>
      </div>
  </div>
  )
  } else {
  return false
  }
  }
}

const divStyle = {
  //width: '40%',
  margin: 'auto',
};

const settingsData = {
	"eka": [
		["bussi", "bussimatkoille"],
		["viikonloppu", "viikonlopuksi"],
		["elämä", "koko elämän ajaksi"]
	],
	"toka": [
    ["satu", "satumainen"],
		["hauska", "hauska"],
		["jännittävätaipelottava", "jännittävä tai pelottava"],
		["realismi", "realistinen"],
		["romanttinen", "romanttinen"]
	],
	"kolmas": [
    ["100000eaa-sodat(1944)", "100 000 eaa–1944"],
    ["1945-1989", "1945–1989"],
    ["1990-2016", "1990–2017"],
    ["tulevaisuuteen", "tulevaisuuteen"],
	],
	"neljäs": [
		["nainen", "nainen"],
		["mies", "mies"],
		["lapsi", "lapsi"],
		["jotainaivanmuuta", "jotain aivan muuta"]
	],
	"viides": [
		["viihdyttaa", "viihdyttää"],
		["sivistää", "sivistää"],
		["oivalluksiajayllatyksia", "yllättää ja tarjoaa oivalluksia"],
	]
}



function MobileDetect() {
  let mobile;
    if ($(window).width() < 990){
        mobile = true
    }
    else {
        mobile = false
    }
    return mobile
}

class BookMachine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        mobile: MobileDetect(),
        tulokset: ["", "", "", "", ""],
        panic: false,
        container: null
    };
    this.sifter = new Sifter(data)
    this.handleChange = this.handleChange.bind(this);
    this.handlePanicState = this.handlePanicState.bind(this);
    }

    updateDimensions() {
      if(window.innerWidth < 990) {
        this.setState({ mobile: true});
      } else {
        this.setState({ mobile: false });
      }

    }

    componentDidMount() {
      this.updateDimensions();
  //    window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    sifterSearch()  {
      if (this.state.panic === false) {
        let result = this.sifter.search(this.state.tulokset[0] + " " + this.state.tulokset[1] + " " + this.state.tulokset[2] + " " + this.state.tulokset[3] + " " +  this.state.tulokset[4], {
            fields: ['Haluan että kirja', 'Minulla on aikaa', 'Kirjan pitää sijoittua', 'Päähenkilö on', 'Toivon että kirjan maailma on'],
            sort: [{field: 'Kirja', direction: 'asc'}],
            limit: 30
        });
        // If there is results...
        if(result.total) {
          // Group by score into arrays (lodash)
          let a = groupBy(result.items, function(n) {
            return n.score;
          });
          // Shuffle arrays
          _.forEach(a, function(value) {
              let shuffled = new Shuffle(value)
              shuffled.createRandomArray();
            });
          // Result: Five books randomized and grouped by score
          return a;
        } else {
          return false;
        }
      } else {
        return false
      }

    }

    handlePanicState () {
      this.setState( {
          panic: true
      });
    }


    handleChange(mobile, answerArray, container) {
      let tulokset = this.state.tulokset;
      tulokset[container] = answerArray;
      this.setState({
           tulokset: tulokset,
           container: container,
           panic: false
      });
    }

  render () {
    let resultObject = this.sifterSearch()
    return (
      <div className="container" style={divStyle}>
        <Header arr={this.state.tulokset} handlePanicState={this.handlePanicState}/>
        <div className="row customization">
            <div className="col-lg-5" id="inputs">
              <InputSet mobile={this.state.mobile}  resultData={resultObject} number={0} name="1. Etsin luettavaa..." data={settingsData.eka} container={this.state.container} resultFunc={this.handleChange} />
              <InputSet mobile={this.state.mobile}  resultData={resultObject} number={1} name="2. Kirjan pitää olla..." data={settingsData.toka} container={this.state.container} resultFunc={this.handleChange} />
              <InputSet mobile={this.state.mobile}  resultData={resultObject} number={2} name="3. Kirjan tapahtumat sijoittuvat vuosille..." data={settingsData.kolmas} container={this.state.container} resultFunc={this.handleChange} />
              <InputSet mobile={this.state.mobile}  resultData={resultObject} number={3} name="4. Päähenkilö on..." data={settingsData.neljäs} container={this.state.container} resultFunc={this.handleChange} />
              <InputSet mobile={this.state.mobile}  resultData={resultObject} number={4} name="5. Haluan, että kirja.." data={settingsData.viides} container={this.state.container} resultFunc={this.handleChange}/>
            </div>
            <div className="scrollAnchor"></div>
          <ResultCont mobile={this.state.mobile} resultData={resultObject} panic={this.state.panic} />
        </div>
      </div>
      )
  }
}


ReactDOM.render(
  <BookMachine />,
  document.getElementById('root')
);
